import { render, staticRenderFns } from "./EventProduct.vue?vue&type=template&id=853a4d42&scoped=true&"
import script from "./EventProduct.vue?vue&type=script&lang=js&"
export * from "./EventProduct.vue?vue&type=script&lang=js&"
import style0 from "./EventProduct.vue?vue&type=style&index=0&id=853a4d42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853a4d42",
  null
  
)

export default component.exports